import { Component, inject } from '@angular/core';
import { ToastrService } from '../../../core/services/toastr/toastr.service';

@Component({
  selector: 'app-toastr',
  standalone: true,
  imports: [],
  templateUrl: './toastr.html',
  styleUrl: './toastr.scss',
})
export class Toastr {
  private toastrService = inject(ToastrService);

  protected toastrs = this.toastrService.toastrsReadonly;

  dismiss(id: string): void {
    this.toastrService.dismiss(id);
  }
}